<mat-form-field subscriptSizing="dynamic" class="w-full">
  <input
    matInput
    [formControl]="control"
    [matAutocomplete]="countryAuto"
    [placeholder]="placeholder"
    autocomplete="off" />
  <mat-autocomplete
    #countryAuto="matAutocomplete"
    [displayWith]="displayCountry">
    @for (option of filteredCountries$ | async; track option.code) {
      <mat-option [value]="option">
        <div class="flex items-center gap-2">
          <rms-flag-icon
            [countryCode]="option.code"
            [width]="20" />
          <span>{{ option.name }}</span>
          <span class="text-gray-400 text-sm">+{{ option.callingCode }}</span>
        </div>
      </mat-option>
    }
  </mat-autocomplete>
</mat-form-field>
